import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { ElMessage } from 'element-plus';
import { Base64 } from 'js-base64';
import { apiGameRoles, apiGameServerList, apiGameSubList } from '@/api/gameApi';
import { apiGameRoleConfirmRole } from '@/api/goodsApi';
import { getGameConfigById } from '@/hooks/useGameConfig';
import { useAuthStore } from '@/store/modules/auth';
import { UseReportData } from '@/hooks/useReportData';
import { GAME_FORM_DATA } from '@/utils/constances';
import { useCommonStatus } from '@/store/modules/commonStaus';
import { useGameStore } from '@/store/modules/game';
import { useLanguageStore } from '@/store/modules/language';
import { CommonConstants } from '@/common/constants';
import eventBus, { COMMON_EVENT_NAME } from '@/utils/eventBus';
import { useDevice } from '@/hooks/useDevice';
import i18n from '@/i18n';
import { useGoodsStore } from '@/store/modules/goodsStore';
export const UseVerifyAccount = function () {
  const {
    isChecked,
    formData,
    verifyRole,
    subList
  } = storeToRefs(useAuthStore());
  const loginType = ref('');
  const agrVisible = ref(false);
  const route = useRoute();
  const verifyLoading = ref(false);
  const {
    currentGameId
  } = storeToRefs(useGameStore());
  const {
    currentCountry
  } = storeToRefs(useLanguageStore());
  const {
    setPreCheckList
  } = useGameStore();
  const {
    isIOS,
    isAndroid,
    isWeixin
  } = useDevice();
  const {
    setPayVisible
  } = useGoodsStore();

  // 是否显示小号列表
  const visibleSubList = ref(false);
  const serverList = ref();
  const {
    setAuthVisible
  } = useAuthStore();
  const currentGameConfig = computed(function () {
    return getGameConfigById(route.path);
  });
  const {
    loadMoyuJsSdk,
    setGuideVisible
  } = useCommonStatus();
  const {
    isMoyuApp
  } = storeToRefs(useCommonStatus());
  const {
    $customEvent
  } = UseReportData();
  //
  const roleIds = ref('');
  const roleList = ref([]);

  // 获取区服列表
  const getServerList = async function () {
    const params = {
      mall_game_id: currentGameConfig.value.id
    };
    const res = await apiGameServerList(params);
    if (res.code === 0 && res.data) {
      if (!formData.value.server_id) {
        var _res$data$;
        formData.value.server_id = ((_res$data$ = res.data[0]) === null || _res$data$ === void 0 ? void 0 : _res$data$.server_id) || '';
      }
      serverList.value = res.data;
      if (verifyRole.value.server_id) {
        formData.value.server_id = verifyRole.value.server_id;
      }
    }
  };
  const getRoleList = async function () {
    const res = await apiGameRoles({});
    if (res.code !== 0) return;
    roleList.value = res.data;
  };
  const onKeyUpRoleId = function () {
    formData.value.role_id = formData.value.role_id.replace(/\D/g, '');
  };

  // 获取小号列表
  async function getSubList(route) {
    const params = _objectSpread({
      mall_game_id: currentGameId.value
    }, formData.value);
    subList.value = [];
    const res = await apiGameSubList(params);
    if (res.code !== 0) return false;
    subList.value = res.data;
    const localTokens = JSON.parse(localStorage.getItem('tokens') || '{}');
    localTokens[route.path] = (res === null || res === void 0 ? void 0 : res.access_token) || '';
    localStorage.setItem('tokens', JSON.stringify(localTokens));
    return true;
  }

  // 确认角色
  async function onConfirmRole(role) {
    if (!role) return false;
    const params = {
      mall_game_id: currentGameId.value,
      server_id: role.server_id,
      role_id: role.role_id,
      cpUid: role.cpUid,
      payRegion: currentCountry.value.key
    };
    const res = await apiGameRoleConfirmRole(params);
    if (res.code !== 0) {
      return false;
    }
    verifyRole.value = res.data;
    return true;
  }

  // 清空绑定信息
  function clearVerifyRole() {
    const initRole = {
      cUid: '',
      cpUid: '',
      cp_ext: '',
      game_role_bind_time: '',
      game_role_status: 0,
      mall_game_id: 0,
      game_name: '',
      mall_game_role_id: 0,
      mall_user_account: '',
      role_name: '',
      server_id: '',
      server_name: '',
      role_id: '',
      cid: '',
      vipName: '',
      nextAmount: 0,
      levelFlag: false,
      benefitNum: 0,
      benefitNotes: []
    };
    setPreCheckList({});
    verifyRole.value = initRole;
    formData.value.role_id = '';
    formData.value.cpUid = '';
    const gameFormData = localStorage.getItem(GAME_FORM_DATA);
    const res = localStorage.getItem('gameRoleInfo');
    if (res) {
      try {
        const roleInfoObj = JSON.parse(res);
        if (roleInfoObj[window.globalRoute.path]) {
          delete roleInfoObj[window.globalRoute.path];
        }
        localStorage.setItem('gameRoleInfo', JSON.stringify(roleInfoObj));
      } catch (e) {
        console.log(e);
      }
    }
    if (gameFormData) {
      try {
        const gameFormDataObj = JSON.parse(gameFormData);
        if (gameFormDataObj[window.globalRoute.path]) {
          delete gameFormDataObj[window.globalRoute.path];
        }
        localStorage.setItem(GAME_FORM_DATA, JSON.stringify(gameFormDataObj));
      } catch (e) {
        console.log(e);
      }
    }
    const localTokens = JSON.parse(localStorage.getItem('tokens') || '{}');
    delete localTokens[window.globalRoute.path];
    localStorage.setItem('tokens', JSON.stringify(localTokens));
  }
  const handleVerifyMiddle = function () {
    if (CommonConstants.IS_AREA === 'cn') {
      if (!isChecked.value) {
        loginType.value = 'verify';
        agrVisible.value = true;
        return;
      }
    }
    onVerify();
  };

  // 验证角色，拉取小号列表
  const onVerify = async function () {
    $customEvent('wm_click_verify_role', _objectSpread(_objectSpread({}, formData.value), {}, {
      loginType: 1
    }));
    verifyLoading.value = true;
    // 摸鱼社内的创魔选择角色就是小号列表，直接确认角色
    if (isMoyuApp.value && route.path === '/cncm') {
      await handleConfirmRole(formData.value);
      verifyLoading.value = false;
      return;
    }
    const res = await getSubList(route);
    if (!res) {
      const eParams = _objectSpread(_objectSpread({}, formData.value), {}, {
        loginType: 1
      });
      verifyLoading.value = false;
      $customEvent('wm_verify_result', _objectSpread(_objectSpread({}, eParams), {}, {
        result: 0
      }));
      return;
    }
    // 只有一个小号的时候，自动确认角色
    if (subList.value.length === 1) {
      await handleConfirmRole(subList.value[0]);
    } else if (subList.value.length > 1) {
      visibleSubList.value = true;
    }
    verifyLoading.value = false;
  };

  // 切换账号
  const onSwitchVerify = async function () {
    var _route$query;
    const eParams = _objectSpread({}, formData.value);
    $customEvent('wm_login_switch', eParams);
    roleIds.value = '';
    clearVerifyRole();
    if (isMoyuApp.value) {
      await loadMoyuJsSdk(route.path, function () {
        console.log(111);
      });
    }
    eventBus.emit(COMMON_EVENT_NAME.REFRESH_GOODS_LIST);
    eventBus.emit(COMMON_EVENT_NAME.UPDATE_ACTIVITY);
    eventBus.emit(COMMON_EVENT_NAME.INIT_VOUCHER_DATA);
    const webSource = (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.webSource;
    const path = window.location.origin + window.location.pathname;
    const baseUrl = CommonConstants.IS_CN ? `${path}#${currentGameConfig.value.path}` : `${path}`;
    if (webSource === '1') {
      window.location.href = baseUrl;
      setTimeout(function () {
        setAuthVisible(true);
      }, 100);
    }
    if (webSource === '2') {
      window.location.href = baseUrl;
      setTimeout(function () {
        setPayVisible(true);
      }, 100);
    }
  };
  const handleConfirmRole = async function (role) {
    const res = await onConfirmRole(role);
    const eParams = _objectSpread(_objectSpread({}, formData.value), {}, {
      loginType: 1
    });
    $customEvent('wm_verify_result', _objectSpread({
      result: res ? 1 : 0
    }, eParams));
    if (!res) return false;
    $customEvent('wm_role_verification', eParams);
    // 根据游戏ID 保存当前游戏的角色信息
    const gameFormData = localStorage.getItem(GAME_FORM_DATA);
    const localRoleInfo = JSON.parse(localStorage.getItem('gameRoleInfo') || '{}');
    localRoleInfo[route.path] = verifyRole.value;
    localStorage.setItem('gameRoleInfo', JSON.stringify(localRoleInfo));
    const tempFormData = gameFormData ? JSON.parse(gameFormData) : {};
    tempFormData[route.path] = formData.value;
    localStorage.setItem(GAME_FORM_DATA, JSON.stringify(tempFormData));
    setAuthVisible(false);
    eventBus.emit(COMMON_EVENT_NAME.ACTIVITY_TIPS);
    eventBus.emit(COMMON_EVENT_NAME.REFRESH_GOODS_LIST);
    eventBus.emit(COMMON_EVENT_NAME.UPDATE_ACTIVITY);
    return res;
  };

  // 在摸鱼社内切换角色
  const onChangeRole = async function (e) {
    const ids = e.split('&');
    formData.value.server_id = ids[0];
    formData.value.role_id = ids[1];
    formData.value.cpUid = ids[2];
  };
  const getAutoLoginUrl = function () {
    let url = [];
    if (isIOS()) {
      if (isWeixin.value) {
        var _currentGameConfig$va;
        url = (_currentGameConfig$va = currentGameConfig.value) === null || _currentGameConfig$va === void 0 ? void 0 : _currentGameConfig$va.wechatInnerUrlIOS;
      } else {
        var _currentGameConfig$va2;
        url = (_currentGameConfig$va2 = currentGameConfig.value) === null || _currentGameConfig$va2 === void 0 ? void 0 : _currentGameConfig$va2.wechatOuterUrlIOS;
      }
    } else if (isAndroid.value) {
      var _currentGameConfig$va3;
      url = (_currentGameConfig$va3 = currentGameConfig.value) === null || _currentGameConfig$va3 === void 0 ? void 0 : _currentGameConfig$va3.wechatOuterUrlAND;
    }
    return url;
  };
  const handleToApp = function (webSource) {
    if (formData.value.role_id && formData.value.server_id) {
      ElMessage.warning(i18n.global.t('i18n-auto-login-tips'));
      return;
    }
    if (isWeixin.value) {
      setGuideVisible(true);
      return;
    }
    if (CommonConstants.IS_AREA === 'cn') {
      if (!isChecked.value) {
        loginType.value = 'autoVerify';
        agrVisible.value = true;
        return;
      }
    }
    const schemeArr = getAutoLoginUrl();
    const path = window.location.origin + window.location.pathname;
    const baseUrl = CommonConstants.IS_CN ? `${path}#${currentGameConfig.value.path}?webSource=${webSource}` : `${path}?webSource=${webSource}`;
    const encoded = Base64.encode(baseUrl);
    window.location.href = `${schemeArr[0]}://cnmall?baseUrl=${encoded}`;
  };
  const handleAgreeAgr = function (webSource) {
    agrVisible.value = false;
    isChecked.value = true;
    if (loginType.value === 'verify') {
      onVerify();
    } else {
      handleToApp(webSource);
    }
  };
  return {
    isChecked,
    roleIds,
    serverList,
    roleList,
    verifyLoading,
    visibleSubList,
    getServerList,
    getRoleList,
    onChangeRole,
    onVerify,
    handleConfirmRole,
    onSwitchVerify,
    onKeyUpRoleId,
    onConfirmRole,
    getSubList,
    clearVerifyRole,
    handleToApp,
    agrVisible,
    handleAgreeAgr,
    handleVerifyMiddle
  };
};